export const config = {
    ga4Id: 'G-N2QDCQM2M1',
    fhirpathApi: 'https://api.fhirpath.me'
}